import RevisionManager from './RevisionManager';

export default RevisionManager;
